<template>
    <dialog-modal ref="modal" :processing="false" message="" button_classes="ml-2">
    <template v-slot:button>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="1rem"
      height="1rem"
      viewBox="0 0 172 172"
      style="fill: #ffffff"
    >
      <g
        fill="none"
        fill-rule="nonzero"
        stroke="none"
        stroke-width="1"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke-miterlimit="10"
        stroke-dasharray=""
        stroke-dashoffset="0"
        font-family="none"
        font-weight="none"
        font-size="none"
        text-anchor="none"
        style="mix-blend-mode: normal"
      >
        <path d="M0,172v-172h172v172z" fill="none"></path>
        <g fill="#576B35">
          <path
            d="M86,6.88c-43.65603,0 -79.12,35.46397 -79.12,79.12c0,43.65603 35.46397,79.12 79.12,79.12c43.65603,0 79.12,-35.46397 79.12,-79.12c0,-43.65603 -35.46397,-79.12 -79.12,-79.12zM86,13.76c39.93779,0 72.24,32.30221 72.24,72.24c0,39.93779 -32.30221,72.24 -72.24,72.24c-39.93779,0 -72.24,-32.30221 -72.24,-72.24c0,-39.93779 32.30221,-72.24 72.24,-72.24zM86,37.84c-5.69958,0 -10.32,4.62042 -10.32,10.32c0,5.69958 4.62042,10.32 10.32,10.32c5.69958,0 10.32,-4.62042 10.32,-10.32c0,-5.69958 -4.62042,-10.32 -10.32,-10.32zM72.24,72.24v6.88h3.44h3.44v44.72h-3.44h-3.44v6.88h3.44h3.44h13.76h3.44h3.44v-6.88h-3.44h-3.44v-51.6h-3.44h-13.76z"
          ></path>
        </g>
      </g>
    </svg>
    </template>
    <template v-slot:header>
        Stock Staus Information
      </template>

      <div class="modal__formcontainer">
    <div class="overflow-y-auto overscroll-contain h-full grid gap-8 p-8">
      <div class="text-block" v-html="info"></div>
    </div>

  </div>

  </dialog-modal>
</template>

<script>
import DialogModal from "./DialogModal.vue"

export default {
  components: {
    DialogModal
  },
  props: {
    info: String,
  },
  
};
</script>